var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.option},[_c(_vm.dynamicIcon,{tag:"component"}),_c('div',{class:_vm.$style.optionText},[_vm._v(" "+_vm._s(_vm.option.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }